import routerOptions0 from "C:/Users/BenjaminGrand/Documents/live-display/node_modules/.pnpm/nuxt@4.4.6_@babel+plugin-sy_02de69f4a88b6da66d3766b992f88af3/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  strict: true,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}